module.exports = __webpack_public_path__ + "static/media/NoirPro-SemiBold.e928d2a2.woff2";